import { useEffect, useMemo, useState } from 'react';
import api from '../../services/api';
import { inputMaskMapper, ufs } from '../../utils/constants';
import Modalpdf from '../Modalpdf';

import { Chip } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { AttachFile } from '@material-ui/icons';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import { QRCodeSVG } from 'qrcode.react';
import { FaCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/AuthContext';
import {
  DELETE_DOCUMENT_BY_ID,
  DELETE_PENDENCIES,
  PATCH_DOCUMENT_APROVE,
  PATCH_PENDENCIES,
  POST_NEW_DOCUMENT,
  POST_PENDENCIES,
  PUT_PROJECTS,
  SET_APPROVE_PROJECT_ID,
  SET_CANCEL_PAYMENT_ID,
  SET_PAYMENT_ID,
} from '../../services/endpoints';
import Dialogoconfirmacao from '../Dialogoconfirmacao';
import Dialogoencontrarlocalizacao from '../Dialogoencontrarlocalizacao';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import BackupIcon from '@material-ui/icons/Backup';
import CheckIcon from '@material-ui/icons/Check';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteOutlineOutlined from '@material-ui/icons/DeleteOutlineOutlined';
import DescriptionIcon from '@material-ui/icons/Description';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import LabelIcon from '@material-ui/icons/Label';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import { mask } from 'remask';
import { setDeepValue } from '../../utils/objects';
import SimpleBackdrop from '../Backdrop';
import DialogDocumentData from '../DialogDocumentData';
import DialogoPixCode from '../DialogoPixCode';
import GetEditProjectData from '../GetEditProjectData';
import { Container, FielButtons } from './styles';

const sortDesc = (a, b) => new Date(b.created_at) - new Date(a.created_at);
const getLatestReceipt = (receipts = []) =>
  receipts && receipts.length ? [...receipts].sort(sortDesc)[0] : null;

export default function BaseDialogEditProject({ children, ...props }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(true);
  const [dados, setDados] = useState({ ...(props.dados || {}) });
  const [dealers, setDealers] = useState([]);
  const [dealerUf, setDealerUf] = useState(props.dados?.dealer?.state || '');
  const [showCoord, setShowCoord] = useState(false);
  const [showbackdrop, setShowbackdrop] = useState(false);
  const [openNewPendencia, setOpenNewPendencia] = useState(false);
  const [newPendencia, setNewPendencia] = useState({
    project_id: props.dados?.id,
    type: '',
    title: '',
    description: '',
  });
  const [listpendencias, setListpendencias] = useState(
    props.dados?.pendencies || []
  );

  const [listarchives, setListarchives] = useState(
    props.dados?.documents || []
  );
  const [document, setDocument] = useState({
    open: false,
    type: '',
    other_type: '',
    document_additional: '',
  });

  const [showconf, setShowconf] = useState({
    status: false,
    width: 'sm',
    title: 'Confirmar',
    description: '',
    btn_conf: 'Sim',
    btn_cancel: 'Não',
    delete: true,
    dados: '',
    temp: '',
  });

  const [viewPixCode, setViewPixCode] = useState({
    status: false,
    id: '',
    pixCode: '',
  });

  const [showPDF, setShowPDF] = useState({ open: false, file_pdf: '' });
  const [showDocumentData, setShowDocumentData] = useState({
    open: false,
    data: {},
  });
  const [listidx, setListidx] = useState(3);

  const isPhysicalPerson = useMemo(() => !!dados?.client_cpf, [dados]);

  const latestReceipt = getLatestReceipt(dados?.receipts);
  const paymentIsPaid = !!latestReceipt?.is_paid;
  const projectIsApproved = !!dados?.approved_at;

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => props.fechar && props.fechar(), 100);
  };

  const onInputChange = (event) => {
    const field = event.target.name;
    const value = event.target.value;

    if (!field) return;

    const fieldMask = inputMaskMapper[field];

    let aux = { ...dados };

    if (fieldMask) {
      aux = setDeepValue(aux, field, mask(value, fieldMask));
      setDados(aux);

      return;
    }

    aux = setDeepValue(aux, field, value);
    setDados(aux);
  };

  function submitNewArchive() {
    const title = document?.other_type ? document.other_type : document.type;

    if (!title) {
      toast.warn('Título do documento é obrigatório');
      return;
    }

    const fd = new FormData();
    fd.append('file', document.document_additional);
    fd.append('title', title);
    fd.append('project_id', dados.id);

    POST_NEW_DOCUMENT(fd, setListarchives, props.atualizar, setShowbackdrop);

    setDocument({
      open: false,
      type: '',
      other_type: '',
      document_additional: '',
    });
  }

  async function handleSubmitEditProject(e) {
    e.preventDefault();

    const dealer_id = dealers.find((d) => d.name === dados.dealer)?.id;

    const updateData = { ...dados, dealer_id };

    setDados(updateData);

    await PUT_PROJECTS(
      dados.id,
      updateData,
      props.atualizar,
      setDados,
      setShowbackdrop
    );
  }

  function deletePendencia() {
    setTimeout(() => {
      setListpendencias((arr) => arr.filter((p) => p.id !== showconf.dados.id));
      setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }));
      DELETE_PENDENCIES(showconf.dados.id, props.atualizar, setShowbackdrop);
    }, 100);
  }

  function confirmarPendencia() {
    setTimeout(() => {
      setListpendencias((arr) =>
        arr.map((p) =>
          p.id === showconf.dados.id ? { ...p, resolved: !p.resolved } : p
        )
      );
      setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }));
      PATCH_PENDENCIES(showconf.dados, props.atualizar, setShowbackdrop);
    }, 100);
  }

  function confirmarArquivo() {
    setTimeout(async () => {
      setDocument((d) => ({ ...d, document_additional: '' }));
      setListarchives((arr) =>
        arr.map((doc) =>
          doc.id === showconf.dados.id
            ? { ...doc, is_approved: !doc.is_approved }
            : doc
        )
      );
      setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }));

      await PATCH_DOCUMENT_APROVE(
        showconf.dados,
        props.atualizar,
        setShowbackdrop
      );
    }, 100);
  }

  function removerArquivo() {
    setTimeout(() => {
      setDocument((d) => ({ ...d, document_additional: '' }));
      setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }));
    }, 100);
  }

  function deleteArquivoVinculado() {
    setTimeout(async () => {
      setDocument((d) => ({ ...d, document_additional: '' }));
      setListarchives((arr) =>
        arr.filter((doc) => doc.id !== showconf.dados.id)
      );
      setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }));
      await DELETE_DOCUMENT_BY_ID(
        showconf.dados.id,
        props.atualizar,
        setShowbackdrop
      );
    }, 100);
  }

  const handlePixUpdated = (code) => {
    setDados((s) => ({ ...s, pix_code: code }));
    props.onProjectPixUpdated?.(dados.id, code);
  };

  const handleCopy = () => {
    const code = dados?.pix_code || '';
    if (!code) return;
    navigator.clipboard
      .writeText(code)
      .then(() => toast.success('Código copiado com sucesso'))
      .catch(() => {});
  };

  const handlePaymentUpdatedLocal = (receiptId, isPaid) => {
    setDados((s) => ({
      ...s,
      receipts: (s.receipts || []).map((r) =>
        r.id === receiptId ? { ...r, is_paid: isPaid } : r
      ),
    }));
    props.onProjectPaymentUpdated?.(dados.id, receiptId, isPaid);
  };

  const handleProjectApprovalUpdatedLocal = (projectId, isApproved) => {
    setDados((s) => ({
      ...s,
      approved_at: isApproved ? new Date().toISOString() : null,
    }));
    props.onProjectApprovalUpdated?.(dados.id, projectId, isApproved);
  };

  async function handleSubmitPendencia(e) {
    e.preventDefault();

    const fd = new FormData();

    fd.append('project_id', newPendencia.project_id);

    if (newPendencia.type === 'arquivo')
      fd.append('file', document.document_additional);
    fd.append('title', newPendencia.title);
    fd.append('description', newPendencia.description);

    await POST_PENDENCIES(
      fd,
      props.atualizar,
      setListpendencias,
      setShowbackdrop
    );

    setNewPendencia({
      project_id: dados?.id,
      type: '',
      title: '',
      description: '',
    });

    removerArquivo();
    setOpenNewPendencia(false);
  }

  const getDealers = async (value) => {
    await api
      .get(`/dealers/state/${value}`)
      .then((res) => {
        setDealers(res.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (dealerUf) getDealers(dealerUf);
  }, [dealerUf]);

  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          props.fechar();
        }}
        maxWidth="md"
        scroll="body"
        fullScreen={window.innerWidth <= 675}
        fullWidth
        style={{ zIndex: 9999 }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText>
            <Container suspended={dados.suspended}>
              <header>
                <h1>Editar dados do projeto</h1>
                <p>
                  Edite projetos com facilidade e agilidade, em apenas alguns
                  cliques.
                </p>
              </header>

              <content>
                <section>
                  <h4>Informações da Concessionária</h4>

                  <div className="div__multiColumn">
                    <select
                      className="input-custom-style "
                      required
                      name="uf"
                      style={{ flex: 1 }}
                      value={dealerUf || ''}
                      onChange={(e) => {
                        setDados({ ...dados, dealer: '' });
                        setDealerUf(e.target.value);
                      }}
                    >
                      <option value="" disabled>
                        Estado
                      </option>
                      {ufs.map((uf, idx) => (
                        <option value={uf} key={idx}>
                          {uf}
                        </option>
                      ))}
                    </select>

                    <select
                      className="input-custom-style"
                      required
                      disabled={!dealerUf}
                      name="dealer"
                      style={{ flex: 3 }}
                      value={dados.dealer ?? ''}
                      onChange={onInputChange}
                    >
                      <option value="" disabled>
                        Nome da concessionária
                      </option>

                      {dealerUf && dealers.length === 0 && (
                        <option value="" disabled>
                          Nenhuma concessionária cadastrada
                        </option>
                      )}

                      {dealers.length > 0 &&
                        dealers.map((dealer, idx) => (
                          <option key={idx} value={dealer.name}>
                            {dealer.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </section>

                <section>
                  <h4>Informações do Cliente</h4>

                  <div className="div__multiColumn">
                    <input
                      className="input-custom-style"
                      type="text"
                      placeholder={isPhysicalPerson ? 'CPF' : 'CNPJ'}
                      value={
                        isPhysicalPerson
                          ? dados.client_cpf || ''
                          : dados.client_cnpj || ''
                      }
                      onChange={onInputChange}
                      name={isPhysicalPerson ? 'client_cpf' : 'client_cnpj'}
                      style={{ flex: 1 }}
                      required
                    />

                    <input
                      className="input-custom-style"
                      type="text"
                      placeholder={
                        isPhysicalPerson ? 'Nome completo' : 'Razão social'
                      }
                      value={dados.client_name || ''}
                      onChange={onInputChange}
                      name="client_name"
                      style={{ flex: 2 }}
                      required
                    />
                  </div>
                </section>

                <GetEditProjectData
                  projectType={dados.type}
                  dados={dados}
                  showCoord={showCoord}
                  setDados={setDados}
                  setShowCoord={setShowCoord}
                  onInputChange={onInputChange}
                />

                {!dados?.finished_at &&
                  !dados?.suspended &&
                  user?.role === 'GERENTE' && (
                    <div className="div__payments">
                      <h4>Pagamento</h4>
                      <div className="buttons__payments">
                        <Tooltip
                          placement="bottom-start"
                          title={
                            paymentIsPaid
                              ? 'Cancelar pagamento'
                              : 'Confirmar pagamento'
                          }
                        >
                          <span>
                            <button
                              className={
                                paymentIsPaid
                                  ? 'button_payment button_cancel_payment'
                                  : 'button_payment'
                              }
                              onClick={() => {
                                if (!latestReceipt) {
                                  toast.warn(
                                    'O recibo de pagamento não foi encontrado'
                                  );
                                  return;
                                }

                                const receiptId = latestReceipt.id;
                                if (paymentIsPaid) {
                                  setShowconf({
                                    ...showconf,
                                    status: true,
                                    width: 'sm',
                                    title: 'Confirmar',
                                    description: `Deseja realmente cancelar o pagamento do projeto de ${dados.client_name}?`,
                                    btn_conf: 'Sim',
                                    btn_cancel: 'Não',
                                    delete: true,
                                    dados,
                                    type: 'SET_CANCEL_PAYMENT_ID',
                                    receiptId,
                                  });
                                } else {
                                  setShowconf({
                                    ...showconf,
                                    status: true,
                                    width: 'sm',
                                    title: 'Confirmar',
                                    description: `Deseja realmente confirmar o pagamento do projeto de ${dados.client_name}?`,
                                    btn_conf: 'Sim',
                                    btn_cancel: 'Não',
                                    delete: false,
                                    dados,
                                    type: 'SET_PAYMENT_ID',
                                    receiptId,
                                  });
                                }
                              }}
                            >
                              {paymentIsPaid
                                ? 'Cancelar pagamento'
                                : 'Confirmar pagamento'}
                            </button>
                          </span>
                        </Tooltip>

                        <Tooltip
                          placement="bottom-start"
                          title={
                            dados.pix_code ? 'Editar Pix' : 'Adicionar Pix'
                          }
                        >
                          <button
                            className="button_payment"
                            onClick={() =>
                              setViewPixCode({
                                status: true,
                                id: dados.id,
                                pixCode: dados.pix_code || '',
                              })
                            }
                          >
                            <AttachMoneyIcon />
                            {dados.pix_code ? 'Editar Pix' : 'Adicionar Pix'}
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                  )}

                {!dados?.finished_at &&
                  !dados?.suspended &&
                  user?.role === 'GERENTE' && (
                    <div className="div__payments">
                      <h4>Aprovação do Projeto</h4>
                      <div className="buttons__payments">
                        <Tooltip
                          placement="bottom-start"
                          title="Aprovar projeto"
                        >
                          <span>
                            <button
                              className={
                                projectIsApproved
                                  ? 'button_payment button_cancel_payment'
                                  : 'button_payment'
                              }
                              onClick={() => {
                                const projectId = dados.id;
                                setShowconf({
                                  ...showconf,
                                  status: true,
                                  width: 'sm',
                                  title: projectIsApproved
                                    ? 'Desaprovar'
                                    : 'Aprovar',
                                  description: `Deseja realmente ${
                                    projectIsApproved ? 'desaprovar' : 'aprovar'
                                  } o projeto de ${dados.client_name}?`,
                                  btn_conf: 'Sim',
                                  btn_cancel: 'Não',
                                  delete: true,
                                  dados,
                                  type: 'SET_APPROVE_PROJECT_ID',
                                  projectId,
                                });
                              }}
                            >
                              {projectIsApproved
                                ? 'Desaprovar projeto'
                                : 'Aprovar projeto'}
                            </button>
                          </span>
                        </Tooltip>
                      </div>
                    </div>
                  )}

                {dados?.pix_code && user?.role === 'GERENTE' && (
                  <div>
                    <h4>Pix do Projeto</h4>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 10,
                      }}
                    >
                      <QRCodeSVG value={dados?.pix_code} />
                      <div>
                        <button className="button_copy" onClick={handleCopy}>
                          {dados?.pix_code?.length > 15
                            ? `${dados?.pix_code.slice(0, 15)}...`
                            : dados?.pix_code}{' '}
                          <FaCopy />
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {dados.comments && (
                  <>
                    <h4>Observações</h4>
                    <div className="div__oneRow" style={{ maxWidth: '100%' }}>
                      <p>{dados.comments}</p>
                    </div>
                  </>
                )}

                <section>
                  <div className="div__contHeader">
                    <h4>Pendências</h4>

                    {!dados?.finished_at && !dados.suspended && (
                      <button
                        type="button"
                        className="tertiary-button-style"
                        onClick={() => setOpenNewPendencia(true)}
                      >
                        + Adicionar nova pendência
                      </button>
                    )}
                  </div>

                  {openNewPendencia &&
                    (!dados?.finished_at || !dados?.suspended) && (
                      <form onSubmit={handleSubmitPendencia}>
                        <div
                          className="div__oneRow"
                          style={{ maxWidth: '100%' }}
                        >
                          <input
                            type="text"
                            name="title"
                            placeholder="Título da pendência"
                            value={newPendencia.title}
                            onChange={(e) =>
                              setNewPendencia((p) => ({
                                ...p,
                                [e.target.name]: e.target.value,
                              }))
                            }
                            style={{ flex: 1 }}
                            required
                          />
                          <select
                            required
                            name="type"
                            style={{ flex: 1 }}
                            value={newPendencia.type}
                            onChange={(e) => {
                              setNewPendencia((p) => ({
                                ...p,
                                [e.target.name]: e.target.value,
                              }));
                              removerArquivo();
                            }}
                          >
                            <option value="" disabled>
                              Tipo de pendência
                            </option>
                            <option value="mensagem">Informação</option>
                            <option value="arquivo">Arquivo</option>
                          </select>
                        </div>
                        <div className="div__oneRow">
                          <textarea
                            id="description"
                            name="description"
                            placeholder="Nota de pendência"
                            value={newPendencia.description}
                            onChange={(e) =>
                              setNewPendencia((p) => ({
                                ...p,
                                [e.target.name]: e.target.value,
                              }))
                            }
                            required
                          />
                        </div>

                        {newPendencia.type === 'arquivo' ? (
                          <>
                            <input
                              type="file"
                              id="document_additional"
                              name="document_additional"
                              required
                              onChange={(e) => {
                                const f = e.target.files?.[0];
                                if (!f) return;
                                if (
                                  f.type === 'application/pdf' ||
                                  f.type === 'image/png' ||
                                  f.type === 'image/jpeg' ||
                                  f.type === 'application/x-compressed' ||
                                  f.type === 'application/x-zip-compressed' ||
                                  f.type === 'application/zip'
                                ) {
                                  setDocument((d) => ({
                                    ...d,
                                    document_additional: f,
                                  }));
                                } else {
                                  toast.error(
                                    'Tipo de arquivo inválido, insira .pdf, .png ou .jpeg'
                                  );
                                }
                              }}
                            />

                            <label
                              className={
                                document.document_additional
                                  ? 'div__newfieldarchive div__selectedFieldArchive'
                                  : 'div__newfieldarchive'
                              }
                              htmlFor={
                                document.document_additional
                                  ? ''
                                  : 'document_additional'
                              }
                              onClick={() => {
                                if (document.document_additional) {
                                  setShowconf({
                                    ...showconf,
                                    status: true,
                                    dados: document,
                                    temp: 'document_additional',
                                    removeDocument: true,
                                    pendencia: false,
                                  });
                                }
                              }}
                            >
                              <div className="div__newfieldarchive_in">
                                <div className="div__dataArchive">
                                  <AttachFileIcon />
                                  <div className="div__info">
                                    <p style={{ textTransform: 'uppercase' }}>
                                      <LabelIcon
                                        style={{
                                          fontSize: '1rem',
                                          marginBottom: '-0.2rem',
                                        }}
                                      />{' '}
                                      {document.type || ' . . . '}{' '}
                                      {document.other_type
                                        ? `(${document.other_type})`
                                        : ''}
                                    </p>
                                    <p>
                                      <b>Nome: </b>
                                      {document.document_additional
                                        ? document.document_additional.name
                                        : '...'}
                                    </p>
                                    <p>
                                      <b>Tamanho: </b>
                                      {document.document_additional
                                        ? (
                                            document.document_additional.size /
                                            (1024 * 1024)
                                          ).toFixed(2) + 'Mb'
                                        : '...'}
                                    </p>
                                    <p>
                                      <b>Tipo de arquivo: </b>
                                      {document.document_additional
                                        ? document.document_additional.type.split(
                                            '/'
                                          )[1]
                                        : '...'}
                                    </p>
                                  </div>
                                </div>
                                <div className="div__env_archive">
                                  {document.document_additional ? (
                                    <div>
                                      <DeleteIcon
                                        style={{ fontSize: '1.5rem' }}
                                      />{' '}
                                      Remover arquivo
                                      <br /> selecionado
                                    </div>
                                  ) : (
                                    <div>
                                      <BackupIcon /> Clique para anexar o
                                      arquivo
                                      <br />
                                      (.png .jpeg .pdf .rar .zip)
                                    </div>
                                  )}
                                </div>
                              </div>
                            </label>

                            <div className="div__moreFiles">
                              <button
                                type="button"
                                className="btn__cancel"
                                onClick={() => {
                                  setNewPendencia({
                                    project_id: dados?.id,
                                    type: '',
                                    title: '',
                                    description: '',
                                  });
                                  removerArquivo();
                                  setOpenNewPendencia(false);
                                }}
                              >
                                Cancelar
                              </button>
                              <button
                                type="submit"
                                className="btn__newFile"
                                style={{
                                  pointerEvents:
                                    !document.document_additional && 'none',
                                  filter:
                                    !document.document_additional &&
                                    'grayscale(1)',
                                }}
                              >
                                Cadastrar nova pendência
                              </button>
                            </div>
                          </>
                        ) : (
                          <div className="div__moreFiles">
                            <button
                              type="button"
                              className="btn__cancel"
                              onClick={() => {
                                setNewPendencia({
                                  project_id: dados?.id,
                                  type: '',
                                  title: '',
                                  description: '',
                                });
                                setOpenNewPendencia(false);
                              }}
                            >
                              Cancelar
                            </button>
                            <button
                              type="submit"
                              className="btn__newFile"
                              style={{ marginTop: '1rem' }}
                            >
                              Cadastrar nova pendência
                            </button>
                          </div>
                        )}
                      </form>
                    )}

                  <div className="div__listpendencias">
                    {listpendencias?.length > 0
                      ? listpendencias.map((pendencia) => (
                          <div key={pendencia.id} className="div__pendencias">
                            <div className="div__info" style={{ flex: 10 }}>
                              <h5>
                                {pendencia.resolved ? (
                                  <CheckCircleOutlineIcon className="icone_success" />
                                ) : (
                                  <ErrorOutlineIcon className="icone_warn" />
                                )}
                                {pendencia.title}{' '}
                                <span>
                                  {pendencia.file ? 'Arquivo' : 'Informação'}
                                </span>
                                {pendencia.visualized_at && (
                                  <span>Visualizado pelo integrador</span>
                                )}
                              </h5>
                              <p style={{ marginBottom: 5 }}>
                                {pendencia.description}
                              </p>
                              {pendencia.customer_comment && (
                                <div className="div__respost_pendence">
                                  <div className="div__comment">
                                    <strong>R:</strong>{' '}
                                    {pendencia.customer_comment}
                                  </div>
                                </div>
                              )}
                              {pendencia.customer_file && (
                                <>
                                  <p style={{ marginBottom: 5 }}>
                                    Arquivo anexado pelo integrador
                                  </p>
                                  <Chip
                                    clickable
                                    component="a"
                                    href={pendencia.customer_file_url}
                                    target="_blank"
                                    icon={<AttachFile />}
                                    label={pendencia.customer_file_name}
                                  />
                                </>
                              )}
                            </div>
                            <div
                              className="div__options_pendencias"
                              style={{
                                flex: 2,
                                display: 'flex',
                                justifyContent: 'flex-end',
                              }}
                            >
                              {!pendencia.resolved ? (
                                !dados?.finished_at &&
                                !dados.suspended && (
                                  <button
                                    onClick={() =>
                                      setShowconf({
                                        ...showconf,
                                        status: true,
                                        dados: pendencia,
                                        btn_cancel: 'Voltar',
                                        description:
                                          'Deseja confirmar à resolução da pendência?',
                                        delete: false,
                                        arquivoVinculado: false,
                                        pendencia: true,
                                      })
                                    }
                                  >
                                    <CheckIcon />
                                  </button>
                                )
                              ) : (
                                <p>Resolvido</p>
                              )}
                              {pendencia.file && (
                                <button
                                  onClick={() => {
                                    if (pendencia.file_url) {
                                      window.open(pendencia.file_url, '_blank');
                                    } else if (pendencia.data) {
                                      setShowDocumentData({
                                        open: true,
                                        data: pendencia.data,
                                      });
                                    }
                                  }}
                                >
                                  <VisibilityOutlinedIcon />
                                </button>
                              )}
                              <button
                                className="button_delete"
                                onClick={() =>
                                  setShowconf({
                                    ...showconf,
                                    status: true,
                                    dados: pendencia,
                                    description:
                                      'Deseja realmente remover esta pendência?',
                                    delete: true,
                                    arquivoVinculado: false,
                                    pendencia: true,
                                  })
                                }
                              >
                                <DeleteOutlineOutlined />
                              </button>
                            </div>
                          </div>
                        ))
                      : !openNewPendencia && (
                          <div className="div__nada">
                            Nenhuma pendência cadastrada
                          </div>
                        )}
                  </div>
                </section>

                <section>
                  <div className="div__contHeader">
                    <h4>Arquivos vinculados</h4>

                    {!dados?.finished_at && !dados.suspended && (
                      <button
                        type="button"
                        style={{ display: document.open ? 'none' : 'initial' }}
                        className="tertiary-button-style"
                        onClick={() =>
                          setDocument({
                            ...document,
                            open: true,
                            type: 'Novo arquivo',
                          })
                        }
                      >
                        + Novo arquivo
                      </button>
                    )}
                  </div>

                  {document.open && (
                    <div className="div__field_moreFiles">
                      <div style={{ textAlign: 'left', margin: '0rem 2rem' }}>
                        Novo documento
                      </div>
                    </div>
                  )}

                  {document.open && (
                    <input
                      type="file"
                      id="document_additional_main"
                      name="document_additional_main"
                      required
                      onChange={(e) => {
                        const f = e.target.files?.[0];
                        if (!f) return;
                        if (
                          [
                            'application/pdf',
                            'image/png',
                            'image/jpeg',
                            'application/x-compressed',
                            'application/x-zip-compressed',
                            'application/zip',
                          ].includes(f.type)
                        ) {
                          setDocument((d) => ({
                            ...d,
                            document_additional: f,
                          }));
                        } else {
                          toast.error(
                            'Tipo de arquivo inválido, insira .pdf, .png ou .jpeg'
                          );
                        }
                      }}
                    />
                  )}

                  {document.type && (
                    <div className="div__remove_field_arch">
                      <button
                        type="button"
                        className={
                          document.document_additional
                            ? 'btn__remove_field btn__remove_field_disabled'
                            : 'btn__remove_field'
                        }
                        onClick={() =>
                          setDocument({
                            open: false,
                            type: '',
                            other_type: '',
                            document_additional: '',
                          })
                        }
                      >
                        Remover campo
                      </button>
                    </div>
                  )}

                  {document.type && (
                    <label
                      className={
                        document.document_additional
                          ? 'div__newfieldarchive div__selectedFieldArchive'
                          : 'div__newfieldarchive'
                      }
                      htmlFor={
                        document.document_additional
                          ? ''
                          : 'document_additional_main'
                      }
                      onClick={() => {
                        if (document.document_additional) {
                          setDocument((d) => ({ ...d, open: false }));
                          setTimeout(
                            () =>
                              setDocument((d) => ({
                                ...d,
                                open: true,
                                document_additional: '',
                              })),
                            100
                          );
                        }
                      }}
                    >
                      <div className="div__newfieldarchive_in">
                        <div className="div__dataArchive">
                          <AttachFileIcon />
                          <div className="div__info">
                            <p
                              style={{
                                textTransform: 'uppercase',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <LabelIcon style={{ fontSize: '1rem' }} />{' '}
                              <input
                                style={{
                                  border: 'none',
                                  boxShadow: 'none',
                                  margin: 0,
                                  maxHeight: '0.5rem',
                                  fontSize: '1rem',
                                }}
                                disabled={!!document.document_additional}
                                defaultValue={
                                  document.type
                                    ? document.type
                                    : document.other_type
                                    ? `(${document.other_type})`
                                    : ''
                                }
                                onChange={(e) =>
                                  setDocument((d) => ({
                                    ...d,
                                    other_type: e.target.value,
                                  }))
                                }
                              />
                            </p>
                            <p>
                              <b>Nome: </b>
                              {document.document_additional
                                ? document.document_additional.name
                                : '...'}
                            </p>
                            <p>
                              <b>Tamanho: </b>
                              {document.document_additional
                                ? (
                                    document.document_additional.size /
                                    (1024 * 1024)
                                  ).toFixed(2) + 'Mb'
                                : '...'}
                            </p>
                            <p>
                              <b>Tipo de arquivo: </b>
                              {document.document_additional
                                ? document.document_additional.type.split(
                                    '/'
                                  )[1]
                                : '...'}
                            </p>
                          </div>
                        </div>
                        <div className="div__env_archive">
                          {document.document_additional ? (
                            <div>
                              <DeleteIcon style={{ fontSize: '1.5rem' }} />{' '}
                              Remover arquivo
                              <br /> selecionado
                            </div>
                          ) : (
                            <div>
                              <BackupIcon /> Clique para anexar a conta de
                              energia
                              <br />
                              (.png .jpeg .pdf .rar .zip)
                            </div>
                          )}
                        </div>
                      </div>
                    </label>
                  )}

                  {document.type && (
                    <div className="div__moreFiles">
                      <button
                        type="button"
                        className="btn__newFile"
                        style={{
                          pointerEvents:
                            !document.document_additional && 'none',
                          filter:
                            !document.document_additional && 'grayscale(1)',
                        }}
                        onClick={submitNewArchive}
                      >
                        Enviar novo arquivo
                      </button>
                    </div>
                  )}

                  <div className="div__listArchives">
                    {listarchives?.length > 0 ? (
                      listarchives.slice(0, listidx).map((archive) => (
                        <div key={archive.id} className="div__rowArchive">
                          <div className="div__icon">
                            <DescriptionIcon />
                          </div>
                          <div className="div__data" style={{ flex: 4 }}>
                            <p>
                              <strong>Título: </strong> {archive.title}
                            </p>
                            {archive.file && (
                              <p>
                                <strong>Arquivo: </strong> {archive.file}
                              </p>
                            )}
                            <p>
                              Envio em{' '}
                              {new Date(archive.created_at).toLocaleDateString(
                                'pt-br',
                                {
                                  day: '2-digit',
                                  month: 'long',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                }
                              )}
                            </p>
                          </div>

                          <div className="div__options" style={{ flex: 2 }}>
                            {!archive.is_approved ? (
                              !dados?.finished_at &&
                              !dados?.suspended && (
                                <button
                                  onClick={() =>
                                    setShowconf({
                                      ...showconf,
                                      status: true,
                                      dados: archive,
                                      description:
                                        'Deseja confirmar à aprovação deste arquivo?',
                                      delete: false,
                                      pendencia: false,
                                      arquivoVinculado: true,
                                    })
                                  }
                                >
                                  <CheckIcon />
                                </button>
                              )
                            ) : (
                              <p>Aprovado</p>
                            )}

                            <button
                              onClick={() => {
                                if (archive.file_url) {
                                  window.open(archive.file_url, '_blank');
                                } else if (archive.data) {
                                  setShowDocumentData({
                                    open: true,
                                    data: archive.data,
                                  });
                                }
                              }}
                            >
                              <VisibilityOutlinedIcon />
                            </button>

                            {!dados?.finished_at && !dados.suspended && (
                              <button
                                className="button_delete"
                                onClick={() =>
                                  setShowconf({
                                    ...showconf,
                                    status: true,
                                    dados: archive,
                                    delete: true,
                                    pendencia: false,
                                    arquivoVinculado: true,
                                  })
                                }
                              >
                                <DeleteOutlineOutlined />
                              </button>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="div__nada">
                        Nenhuma arquivo cadastrado
                      </div>
                    )}

                    {listarchives?.length > listidx && (
                      <div
                        className="div__viewMore"
                        onClick={() => setListidx((v) => v + 3)}
                      >
                        Ver mais
                      </div>
                    )}
                  </div>
                </section>
              </content>
            </Container>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <FielButtons>
            <button
              onClick={handleClose}
              className="btn__retornar"
              color="primary"
              style={{ minWidth: '100px' }}
            >
              Voltar
            </button>

            <button
              type="button"
              className="btn__newFile"
              onClick={handleSubmitEditProject}
            >
              Salvar edição
            </button>
          </FielButtons>
        </DialogActions>
      </Dialog>

      {showCoord && (
        <Dialogoencontrarlocalizacao
          fechar={() => setShowCoord(false)}
          dados={dados}
          confirmar={(a) =>
            setDados({
              ...dados,
              longitude: a.lng,
              latitude: a.lat,
            })
          }
        />
      )}

      {showconf.status && (
        <Dialogoconfirmacao
          status={showconf.status}
          width={showconf.width}
          delete={showconf.delete}
          description={showconf.description}
          fechar={() =>
            setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }))
          }
          confirmar={() => {
            if (!showconf.dados) return;

            if (
              showconf.type === 'SET_APPROVE_PROJECT_ID' &&
              showconf.projectId
            ) {
              const projectIsApprovedUpdated = !projectIsApproved;

              SET_APPROVE_PROJECT_ID(
                showconf.projectId,
                projectIsApprovedUpdated,
                () => {
                  handleProjectApprovalUpdatedLocal(
                    showconf.projectId,
                    projectIsApprovedUpdated
                  );
                  props?.onProjectApprovalUpdated?.(
                    dados.id,
                    showconf.projectId,
                    projectIsApprovedUpdated
                  );
                  if (props?.atualizar) {
                    props.atualizar();
                  }
                  setShowconf({
                    ...showconf,
                    status: false,
                    dados: '',
                    temp: '',
                    type: '',
                    projectId: undefined,
                  });
                },
                setShowbackdrop
              );
              return;
            }

            if (showconf.type === 'SET_PAYMENT_ID' && showconf.receiptId) {
              SET_PAYMENT_ID(
                showconf.receiptId,
                () => {
                  handlePaymentUpdatedLocal(showconf.receiptId, true);
                  props?.onProjectPaymentUpdated?.(
                    dados.id,
                    showconf.receiptId,
                    true
                  );
                  setShowconf({
                    ...showconf,
                    status: false,
                    dados: '',
                    temp: '',
                    type: '',
                    receiptId: undefined,
                  });
                },
                setShowbackdrop
              );
              return;
            }

            if (
              showconf.type === 'SET_CANCEL_PAYMENT_ID' &&
              showconf.receiptId
            ) {
              SET_CANCEL_PAYMENT_ID(
                showconf.receiptId,
                () => {
                  handlePaymentUpdatedLocal(showconf.receiptId, false);
                  props?.onProjectPaymentUpdated?.(
                    dados.id,
                    showconf.receiptId,
                    false
                  );
                  setShowconf({
                    ...showconf,
                    status: false,
                    dados: '',
                    temp: '',
                    type: '',
                    receiptId: undefined,
                  });
                },
                setShowbackdrop
              );
              return;
            }

            if (showconf.pendencia) {
              !showconf.delete ? confirmarPendencia() : deletePendencia();
            } else if (showconf.arquivoVinculado) {
              !showconf.delete ? confirmarArquivo() : deleteArquivoVinculado();
            } else if (showconf.removeDocument) {
              removerArquivo();
            }
          }}
        />
      )}

      {showPDF.open && (
        <Modalpdf
          fechar={() => setShowPDF({ open: false, file_pdf: '' })}
          fileUrl={showPDF.file_pdf}
        />
      )}

      {showDocumentData.open && (
        <DialogDocumentData
          fechar={() => setShowDocumentData({ open: false, data: {} })}
          data={showDocumentData.data}
        />
      )}

      {viewPixCode.status && (
        <DialogoPixCode
          pixCode={viewPixCode.pixCode}
          handleSetViewPixCode={setViewPixCode}
          onPixUpdated={handlePixUpdated}
          id={viewPixCode.id}
          status={viewPixCode.status}
          drop={setShowbackdrop}
          fechar={() => setViewPixCode({ status: false, id: '', pixCode: '' })}
        />
      )}

      {showbackdrop && <SimpleBackdrop />}
    </>
  );
}
